<template>
    <Layout :pagetitle="'權限範圍功能設定'">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title mb-0">權限範圍功能設定</h4>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12">
                            <div class="mt-4 mt-xl-0">
                                <h5 class="font-size-14 mb-4">
                                    <i class="mdi mdi-arrow-right text-primary me-1"></i>基本資訊
                                </h5>

                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="form-label" for="financial-address">權限代碼</label>
                                        <div>
                                            <span>{{ form.scopeCode }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label" for="financial-address">權限名稱</label>
                                        <div>
                                            <span>{{ form.scopeName }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="mb-3">
                                            <label class="form-label" for="financial-address">權限描述</label>
                                            <div>
                                                <span>{{ form.description }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-4">
                                        <button type="submit" @click.prevent="assign" :disabled="isCloseBtn"
                                                class="btn btn-primary">
                                            進入指派功能
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <h5 class="font-size-14 mb-4">
                                        <i class="mdi mdi-arrow-right text-primary me-1"></i>擁有功能清單
                                    </h5>
                                    <div class="row">
                                        <Grid :style="{ height: '100%' }" :data-items="ownFunctionGrid.result"
                                              :selected-field="ownFunctionGrid.selectedField" :sortable="true"
                                              :pageable="{ refresh: true, pageSizes: [10, 25, 50, 100], buttonCount: 5 }"
                                              :scrollable="'none'"
                                              :filterable="false" :filter="ownFunctionGrid.filter"
                                              :sort="ownFunctionGrid.sort" :skip="ownFunctionGrid.skip"
                                              :take="ownFunctionGrid.take" :total="ownFunctionGrid.total"
                                              :columns="columns"
                                              @selectionchange="onSelectionChange"
                                              @headerselectionchange="onHeaderSelectionChange" @rowclick="onRowClick"
                                              @pagechange="pageChangeHandler">
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <button type="submit" @click.prevent="removeFunction" :disabled="isCloseBtn"
                                            class="btn btn-danger">移除選取的功能
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="col-lg-12">
                            <div class="mt-4 mt-xl-0">
                                <div class="row d-flex justify-content-between">
                                    <div class="hstack gap-3">
                                        <button type="submit" @click.prevent="back" :disabled="isCloseBtn"
                                                class="btn btn-primary">上一頁
                                        </button>
                                        <div class="vr"></div>

                                    </div>
                                    <div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import {useRoute, useRouter} from 'vue-router';
import Layout from "../../layouts/main";
import {ref, onMounted} from "vue";
import {Grid} from "@progress/kendo-vue-grid";
import {toDataSourceRequestString} from "@progress/kendo-data-query";
import axios from 'axios';

const findScope = async (scopeCode) => {
    const quer_url = '/api/FindScope'
    const init_data = {method: 'GET', accept: 'application/json', headers: {}};
    let result = await fetch(`${quer_url}?scopeCode=${scopeCode}`, init_data)
        .then(response => response.json());
    return {scopeName: result.value.scopeName, description: result.value.description}
}

const fetchData = async (dataState) => {
    const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state
    const base_url = "/api/QueryScopeOwnFunctions";
    const init = {method: "GET", accept: "application/json", headers: {}};
    let fetchResult = await fetch(`${base_url}?${queryStr}`, init)
        .then((response) => response.json())
        .then(({data, total}) => {
            let result = data.map((item) => {
                return {...item, selected: false};
            });
            return {result: result, total: total};
        });

    return fetchResult;
};

export default {

    setup() {
        const router = useRouter();
        const route = useRoute();
        const scopeCode = route.params.id;
        const form = ref({
            scopeCode: scopeCode,
            scopdeName: "",
            description: ""
        });

        const ownFunctionGrid = ref({
            selectedField: "selected",
            sort: null,
            filter: {
                logic: "and",
                filters: [{
                    field: "scopeCode",
                    operator: "eq",
                    value: scopeCode,
                }],
            },
            result: [],
            skip: 0,
            take: 10,
            total: 0,
            staticColumns: [
                {field: "functionCode", title: "功能代號"},
                {field: "name", title: "功能名稱"},
                {field: "sysCode", title: "所屬系統代號"},
                {field: "functionType", title: "功能類型"},
                {field: "description", title: "功能描述"},
                {field: "path", title: "路徑"},
            ],
            formSelected: [],
        });

        onMounted(async () => {

            let formData = await findScope(scopeCode);
            form.value.scopeName = formData.scopeName;
            form.value.description = formData.description;

            //fetch data
            let dataState = {
                skip: ownFunctionGrid.value.skip,
                take: ownFunctionGrid.value.take,
                filter: ownFunctionGrid.value.filter
            };
            let fetchResult = await fetchData(dataState);

            ownFunctionGrid.value.result = fetchResult.result;
            ownFunctionGrid.value.total = fetchResult.total;
            // console.log(fetchResult);

        });

        const isCloseBtn = ref(false);
        return {
            ownFunctionGrid,
            form,
            isCloseBtn,
            router
        };
    },
    components: {
        Layout,
        Grid
    },
    computed: {
        areAllSelected() {
            return this.ownFunctionGrid.result.findIndex((item) => item.selected === false) === -1;
        },
        columns() {
            return [
                {
                    field: "selected",
                    width: "50px",
                    headerSelectionValue: this.areAllSelected,
                },
                ...this.ownFunctionGrid.staticColumns,
            ];
        },
    },
    methods: {
        fetchData: async function (dataState) {
            let data = await fetchData(dataState);
            this.ownFunctionGrid.result = data.result;
            this.ownFunctionGrid.total = data.total;
        },
        pageChangeHandler: function (event) {
            setTimeout(() => {
                this.ownFunctionGrid.skip = event.page.skip;
                this.ownFunctionGrid.take = event.page.take;
                this.fetchData({
                    skip: this.ownFunctionGrid.skip,
                    take: this.ownFunctionGrid.take,
                    filter: this.ownFunctionGrid.filter
                });
            }, 300);
        },
        onHeaderSelectionChange(event) {
            let checked = event.event.target.checked;
            this.ownFunctionGrid.result = this.ownFunctionGrid.result.map((item) => {
                return {...item, selected: checked};
            });
            this.ownFunctionGrid.result.forEach((element) => {
                this.changeApplyFormSelected(element.functionCode, element.selected);
            });
        },
        onSelectionChange(event) {
            event.dataItem[this.ownFunctionGrid.selectedField] = !event.dataItem[this.ownFunctionGrid.selectedField];
            let functionCode = event.dataItem["functionCode"];
            this.changeApplyFormSelected(functionCode, event.dataItem[this.ownFunctionGrid.selectedField]);
        },
        onRowClick(event) {
            event.dataItem[this.ownFunctionGrid.selectedField] = !event.dataItem[this.ownFunctionGrid.selectedField];
            let functionCode = event.dataItem["functionCode"];
            this.changeApplyFormSelected(functionCode, event.dataItem[this.ownFunctionGrid.selectedField]);
        },
        changeApplyFormSelected(functionCode, isSelected) {
            if (isSelected) {
                if (!this.ownFunctionGrid.formSelected.includes(functionCode)) {
                    this.ownFunctionGrid.formSelected.push(functionCode);
                }
            } else {
                if (this.ownFunctionGrid.formSelected.includes(functionCode)) {
                    this.ownFunctionGrid.formSelected = this.ownFunctionGrid.formSelected.filter((x) => x != functionCode);
                }
            }
        },
        back() {
            this.router.push({name: 'scope-list'});
        },
        assign() {
            let scopeCode = this.form.scopeCode;
            this.router.push({name: 'scope-assign-function', params: {id: scopeCode}});
        },
        removeFunction() {
            let form = {
                FunctionCodes: this.ownFunctionGrid.formSelected,
                ScopeCode: this.form.scopeCode
            };
            axios({
                method: "post",
                url: "/api/RemoveScopeFunction",
                headers: {
                    "content-type": "application/json",
                },
                data: form,
            })
                .then(() => {
                    this.fetchData({
                        skip: this.ownFunctionGrid.skip,
                        take: this.ownFunctionGrid.take,
                        filter: this.ownFunctionGrid.filter
                    });
                })
                .catch(() => {
                    this.fetchData({
                        skip: this.ownFunctionGrid.skip,
                        take: this.ownFunctionGrid.take,
                        filter: this.ownFunctionGrid.filter
                    });
                });
            this.ownFunctionGrid.formSelected = [];
        }

    },
};
</script>
